const CommentTarget = {
  IntakeProject: "IntakeProject",
  Milestone: "Milestone",
};

export default CommentTarget;
